import { PropertyMetaData } from './property-meta-data';

export class BoolMetaData extends PropertyMetaData {
    protected override _type = 'Bool';
}
